import React from 'react';
import FormROValue from "../../../../library/form/components/FormROValue1"
import FormButton from "../../../../library/form/components/FormActionButton2"

const RuleMapRow = (props) => {
    const { formObject, rowKey } = props;
    return (
        <li>
            <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "docID" }} className="uiColumn uiColumn150" id="svDocID" />
            <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "docID" }} className="uiColumn uiColumn2000" id="svDocID" />
            <FormButton formObject={formObject} rowKey={rowKey} 
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                className=""
                action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
            />
        </li>
    )
}

export default RuleMapRow